import { XMarkIcon } from '@heroicons/react/16/solid';
import { Button, Modal } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import { useModalsContext } from '../../../../../providers/ModalsProvider/Modals.context.ts';
import { AddWorkspaceModalForm } from './AddWorkspaceModal.form.tsx';
import './AddWorkspaceModal.styles.scss';
import { useWorkspaceContext } from '../../../../../providers/WorkspaceProvider/Workspace.context.ts';

export function AddWorkspaceModal() {
  const { setAddWorkspaceModalIsOpen, addWorkspaceModelIsOpen } =
    useModalsContext();
  const { setWorkspaceSaleSource } = useWorkspaceContext();
  const { t } = useTranslation('sidebar/sidebarComponent');

  return (
    <Modal
      open={addWorkspaceModelIsOpen}
      className="AddWorkspace__Modal"
      backdrop={true}
    >
      <Modal.Header className="AddWorkspace__Modal__Header">
        <p>{t('page.modals.addWorkspace.title')}</p>
        <Button
          shape="circle"
          size="sm"
          color="ghost"
          onClick={() => {
            setAddWorkspaceModalIsOpen(!addWorkspaceModelIsOpen);
            setWorkspaceSaleSource(undefined);
          }}
        >
          <XMarkIcon className="AddWorkspace__Modal__CloseIcon" />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <AddWorkspaceModalForm />
      </Modal.Body>
    </Modal>
  );
}
